import {
  FacebookAuthProvider,
  signInWithRedirect,
} from 'firebase/auth';

const HandleFacebook = async (auth) => {
  const provider = new FacebookAuthProvider();
  await signInWithRedirect(auth, provider);
};

export default HandleFacebook;
